import React, { useRef, useState } from 'react'
import { useEffect } from 'react'

import './OrderPage.css'
import starImg from './../../../assets/icons/arrowDown.png'
import img1 from './../../../assets/icons/arrowDown.png'

import OrderCart from './OrderCart/OrderCart'
import pkbImg from './../../../assets/images/Leo.png'
import Suggestion from './Suggestion/Suggestion'

const OrderPage = () => {

  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [currentScrollPosition, setCurrentScrollPosition] = useState(1300)
  const [stickyPosition, setstickyPosition] = useState(true)
  const [scrollUp, setscrollUp] = useState(-527)
  const rightSidePanelRef = useRef(null)
  useEffect(() => { }, [window.scrollY])
  const [showMore, setShowMore] = useState(false)
  const text =
    "Ground beef, string cheese, ground pork, parmesan, olive oilLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an"
  const [showMoreText2, setShowMoreText2] = useState(false)
  const text2 =
    "Ground beef, string cheese, ground pork, parmesan, olive oilLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an";

  return (
    <div>
      <div className="orderpageMainDiv">
        <div>

        </div>

        <div className="customContainer mt-5 customContainer-order-page">
          <div className="row ">
            <div className="col-12 customOrderCartPadding">
              <div className="row">
                <div className="d-flex justify-content-between distanceBottom">
                  <div className="card-body">
                    <h2 className="productHeading">Cheese-Stuffed Meatballs</h2>

                    <div className="d-flex align-item-center desktopDisplay">
                      <img src={pkbImg} alt="" className="restaurantlogo" />

                      <div className="card-body ">
                        <div className="d-flex align-item-center ">
                          <h3 className="restaurantName">Pot Kettle Black</h3>
                          <div className="d-flex justify-content-between">
                            {/* <img
                              src={starImg}
                              alt=""
                              className="restaurantRating"
                            />
                            <h3 className="OrderPageratingStar">4.5</h3> */}
                            <button className="followButton">Follow</button>
                          </div>
                        </div>

                        <div className="d-flex ResturentCategory">
                          <h6>Burgers | </h6>
                          <h6>&nbsp; Pizza | </h6>
                          <h6>&nbsp; Deserts</h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between">
                    <img src={starImg} alt="" className="starImage" />
                    <h3 className="ratingNumber">4.5</h3>
                  </div>
                </div>


                {screenWidth < 688 ? (
                  <p className="my-1 p-3 paragraph ">
                    {showMore
                      ? text
                      : `${text.split(/\s+/).slice(0, 20).join(' ')}`}

                    <a
                      className="text-decoration-none ms-3"
                      onClick={() => setShowMore(!showMore)}
                      style={{
                        color: '#3D1F1B',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                      }}
                    >
                      {showMore ? 'Show less' : 'Show more'}
                    </a>
                  </p>
                ) : null}

                {screenWidth > 688 ? (
                  <p className="my-1  paragraph ">{text}</p>
                ) : null}

                {/*
                   <p className="my-1 paragraph ">
                  {showMore
                    ? text
                    : `${text.split(/\s+/).slice(0, 20).join(" ")}`}

                    <a
                      className="text-decoration-none ms-3"
                      onClick={() => setShowMore(!showMore)}
                      style={{
                        color: "#3D1F1B",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      {showMore ? "Show less" : "Show more"}
                    </a>
                  </p>
                ) : null}

                {screenWidth > 688 ? (
                  <p className="my-1 paragraph ">{text}</p>
                ) : null}

                {/*
                   <p className="my-1 paragraph ">
                  {showMore
                    ? text
                    : `${text.split(/\s+/).slice(0, 20).join(' ')}`}

                  <a
                    className="text-decoration-none ms-3"
                    onClick={() => setShowMore(!showMore)}
                    style={{
                      color: "#3D1F1B",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    {showMore ? 'Show less' : 'Show more'}
                  </a> 
                  </p>
                  */}
              </div>

              {/* customContainer end */}
            </div>
          </div>
        </div>
        <br />

        {/* customContainer start */}
        <div className="customContainer mt-5 customContainer-order-page">


          <div className="row  d-flex">
            <div className=" col-12 col-md-8 ">
              {/* <PostDisplay /> */}
              {/* <AllPostDisplayComponent />
              <br></br>
              <a href="allpost" className="allPostATag">
                See More
              </a> */}
            </div>

            <div className={`col-0 col-md-4 desktopDisplay`}>
              <div className=''>
                <div className="">
                  <div className="">
                    <div className="row">
                      <div className="col-12 p-3 d-flex justify-content-between">
                        <button
                          data-mdb-ripple-color="dark"
                          type="button"
                          className="btn dsrButton "
                        >
                          Details
                        </button>
                        <button
                          data-mdb-ripple-color="dark"
                          type="button"
                          className=" btn dsrButton "
                        >
                          Story
                        </button>
                        <button
                          data-mdb-ripple-color="dark"
                          type="button"
                          className="btn dsrButton "
                        >
                          Instructions
                        </button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 d-flex justify-content-center">
                        <div className="card OrderfoodcardDetails paragraph">
                          {screenWidth < 688 ? (
                            <p>
                              {showMoreText2
                                ? text2
                                : `${text2.split(/\s+/).slice(0, 20).join(' ')}`}

                              <a
                                className="text-decoration-none ms-3"
                                onClick={() => setShowMoreText2(!showMoreText2)}
                                style={{
                                  color: '#3D1F1B',
                                  cursor: 'pointer',
                                  fontWeight: 'bold',
                                }}
                              >
                                {showMoreText2 ? 'Show less' : 'Show more'}
                              </a>
                            </p>
                          ) : null}
                          {screenWidth > 688 ? <p>{text2}</p> : null}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="row ">
                        <div className="col-12 d-flex justify-content-center">
                          <OrderCart
                            foodItem={'Cheese-Stuffed meatballs'}
                          ></OrderCart>
                        </div>
                      </div>
                      <div className="">
                        <Suggestion />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>


          <div className='main-header'>

          </div>

        </div>
        {/* </div> */}
        {/* </div> */}
      </div>
    </div>
  )
}

export default OrderPage